module.exports = __webpack_public_path__ + "img/emptyList.7ce34897.png";